import { useIntl } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { JSMOverlayTemplate } from "@/components/signup/layouts";
import {
    WhiteScreenInput,
    WhiteScreenLayout,
    WhiteScreenSocial,
    WhiteScreenSubmit
} from "@/components/signup/layouts";

import { GetStartedHeading } from "../../../components";
import { FreeSubheading } from "../components";

export const LoggedOutJsmFree = ({
    shouldForceOverlayView
}: {
    shouldForceOverlayView?: boolean;
}) => {
    const { formatMessage } = useIntl();
    const heading1 = formatMessage(
        {
            id: "BxpUiSignup.SignupForm.header",
            defaultMessage: "Get started with {product}"
        },
        { product: "Jira Service Management" }
    );
    const heading2 = formatMessage({
        id: "BxpUiSignup.SignupForm.subheaderJSM",
        defaultMessage: "Free for up to 3 agents"
    });
    const helpText = formatMessage({
        id: "BxpUiSignup.SignupForm.workCallout",
        defaultMessage:
            "Find teammates, plus keep work and life separate by using your work email."
    });

    // short-circuit before evaluating the experiment is force prop is present
    if (shouldForceOverlayView) {
        return <JSMOverlayLayout />;
    }

    return (
        <WhiteScreenLayout heading1={heading1} heading2={heading2}>
            <AccountCreation
                Input={<WhiteScreenInput helpText={helpText} />}
                Social={<WhiteScreenSocial />}
                Submit={<WhiteScreenSubmit />}
            />
        </WhiteScreenLayout>
    );
};

const JSMOverlayLayout = () => (
    <JSMOverlayTemplate size="sm">
        <GetStartedHeading productName="Jira Service Management" />
        <FreeSubheading />
        <AccountCreation />
    </JSMOverlayTemplate>
);
